var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MatingDetailModule',{attrs:{"select_list":_vm.select_list,"module_list":_vm.module_list,"searchInput":_vm.searchInput},on:{"handleClick":_vm.handleClick,"handleList":_vm.handleList}})
}
var staticRenderFns = []

export { render, staticRenderFns }